import { Action } from "@reduxjs/toolkit";
import { PopularPlaceState } from "./types";
import { isType } from "typescript-fsa";
import { popularPlaceActions } from "./actions";

const initialState: PopularPlaceState = {
  popularPlaces: [],
};

export function PopularPlaceReducer(
  state = initialState,
  action: Action
): PopularPlaceState {
  if (isType(action, popularPlaceActions.fetchPopularPlaces.done)) {
    return {
      ...state,
      popularPlaces: action.payload.result.map((data) => ({
        id: data.id,
        name: data.name,
        name_kh: data.name_kh,
        name_zh: data.name_zh,
      })),
    };
  }

  if (isType(action, popularPlaceActions.resetToInitialState)) {
    return initialState;
  }
  return state;
}
